import { Controller } from "@hotwired/stimulus";
import "./component.scss"

export default class extends Controller {
  static targets = ["share"];

  connect() {
  }

  to100(event) {
    let total = this.getTotal()
    let target = event.target

    if (total > 100) {
      let diff = total - 100
      let value = target.value
      let number = parseInt(value)
      if (!isNaN(number)) {
        number -= diff
        target.value = number
      }
    }
  }

  getTotal() {
    let sum = 0
    this.shareTargets.forEach(input => {
      let value = input.value
      let number = parseInt(value)
      if (!isNaN(number)) {
        sum += number
      }
    });
    return sum
  }

  evenOut() {
    let size = this.shareTargets.length

    let roundedDown = parseInt(100 / size)
    let remainder = 100 % size
    let count = 0

    this.shareTargets.forEach(input => {
      if (count < remainder) {
        input.value = roundedDown + 1
      }
      else {
        input.value = roundedDown
      }
      count += 1
    });
  }
}
